import type { IApplicationDetails } from '@/features/ApplicationForm/types';
import ClientInformationDetails from './ClientInformationDetails';
import RealEstateGoalsDetails from './RealEstateGoalsDetails';

export const GStrategiesApplicationDetails = ({ applicationData, files }: IApplicationDetails) => {
  return (
    <>
      <ClientInformationDetails step1={applicationData?.step1} />
      <RealEstateGoalsDetails step2={applicationData?.step2} />
    </>
  );
};
